import type { SlideProps } from "@/engine/app/offsite-config";

const ROWS = [
  {
    frueher: "Zettel, E-Mail oder Warteschleife am Telefon",
    heute: "Formular oder App — 30 Sekunden, jederzeit",
  },
  {
    frueher: "Jemand tippt die Zahlen von Hand in kVASy ab",
    heute: "Der Webservice schreibt sie automatisch ins System",
  },
  {
    frueher: "Durchlauf: Tage — je nach Postkorb",
    heute: "Durchlauf: Sekunden — nachts wie werktags",
  },
  {
    frueher: "Zahlendreher fallen erst bei der Abrechnung auf",
    heute: "Plausibilitätsprüfung sofort bei der Eingabe",
  },
];

export function Slide03bFrueherHeute(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Ein Zählerstand, zwei Welten</div>
        <h1 className="deck-title rise rise-2">
          Frau Meyer meldet <br />
          <span className="accent">ihren Zählerstand</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Dieselbe Kundin, derselbe Vorgang — vorher und nachher.
        </p>
      </header>

      <div className="status-grid rise rise-4">
        <div className="status-headers">
          <div className="neg">Früher</div>
          <div className="pos">Heute</div>
        </div>
        {ROWS.map((r) => (
          <div key={r.frueher} className="status-row">
            <div className="status-cell neg">
              <span className="status-mark neg">✕</span>
              <span className="status-text">{r.frueher}</span>
            </div>
            <div className="status-cell pos">
              <span className="status-mark pos">✓</span>
              <span className="status-text">{r.heute}</span>
            </div>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>
          Die Zeit, die dabei frei wird, gehört den Fällen, die wirklich Menschen brauchen.
        </span>
      </footer>
    </div>
  );
}
